module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAj0lEQVQ4y2NgGBTAa+21/+Rg2hmQt331/1XHU/+vOJb+P2vbBtIM6NrX9f/vXeb//+8xgPHvu6z/q3fNIc4An3WX/3+4JQTXDMMvbsgQZ0D4huMYmmGYaC88vS6Hofn2FW3iDajcNf//tztccM1fbvOCA5WkWIjedOj/1IN1/yccaP4fufHIAKQDkg0Y2gAAQzOwl4moqcoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PW.png
// module id = 1247
// module chunks = 0